export default {
    trainings: 'Deine Trainingskollektion',
    praemien: 'Deine Prämien',
    deineApotique: 'Deine Apotique',
    deinTeam: 'Dein Team',
    aktionen: 'Aktionen',
    punktehistorie: 'Punktehistorie',
    news: 'News',
};
